import type React from 'react';
import { useEffect, useState } from 'react';

export function useWidth(ref: React.RefObject<HTMLDivElement>) {
  const [width, setWidth] = useState<number | null>(null);

  const updateWidth = () => {
    if (ref && ref.current) {
      setWidth(ref.current.getBoundingClientRect().width);
    }
  };

  useEffect(() => {
    updateWidth();
    window.addEventListener('resize', updateWidth);
    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  return width;
}
